import { AnalyticsEventName } from 'src/modules/analytics/models/analytics-event-name.enum';

import { SideBarMenuItemGroup } from 'src/app/models/side-bar-menu-item-group';
import { UserAccessLevelGroupName } from 'src/app/enums/user-access-level-group-name.enum';
import { AppRouteEnum } from 'src/app/enums/app-route.enum';
import { AppFeatures } from 'src/app/enums/app-features.enum';
import { generalIopMenuItemsGroup } from 'src/app/components/side-bar/consts/general-iop-menu-items-group.const';
import { SideBarMenuItem } from 'src/app/models/side-bar-menu-item';

export const iopMenuItemsGroup: SideBarMenuItemGroup[] = [
  {
    label: 'General',
    menuItems: generalIopMenuItemsGroup
  },
  {
    label: 'Tools',
    menuItems: [
      // {
      //   icon: 'report-data',
      //   routerLink: 'reports',
      //   name: 'Reports / Data'
      // },
      {
        icon: 'manifest',
        name: 'Manifest',
        accessLevelGroup: UserAccessLevelGroupName.ManifestAccessLevelGroup,
        menuItems: <SideBarMenuItem[]>[
          {
            icon: '',
            routerLink: AppRouteEnum.Manifests,
            name: 'Manifest List'
          },
          {
            icon: '',
            routerLink: [AppRouteEnum.Manifests, 'create'],
            name: 'New Manifest'
          },
          {
            icon: '',
            routerLink: AppRouteEnum.PreaccessionManifests,
            name: 'Preaccession Manifest List',
            feature: AppFeatures.PreaccessionManifests
          },
          {
            icon: '',
            routerLink: [AppRouteEnum.PreaccessionManifests, 'create'],
            name: 'New Preaccession Manifest',
            feature: AppFeatures.PreaccessionManifests
          }
        ]
      },
      {
        icon: 'price-estimator',
        routerLink: 'price-estimator',
        gaEvent: AnalyticsEventName.PriceEstimatorNavClick,
        name: 'Price Estimator'
      },
      {
        icon: 'order',
        routerLink: 'supply-orders',
        gaEvent: AnalyticsEventName.SupplyOrdersNavClick,
        name: 'Supply Orders',
        feature: AppFeatures.SupplyOrders
      },
      {
        icon: 'book',
        routerLink: AppRouteEnum.TestCompendium,
        gaEvent: AnalyticsEventName.TestCompendiumNavClick,
        name: 'Test Compendium'
      },
      {
        icon: 'comment',
        routerLink: AppRouteEnum.Chat,
        name: 'Chat',
        feature: AppFeatures.Analytics
      }
    ]
  }
];
